/**
 * Citation — le message auquel on répond : son auteur, une ligne de son texte (ou « Photo »,
 * « Vocal »). En tête d'une bulle (un clic rejoint le message cité) et au-dessus du compositeur
 * quand on prépare une réponse. Un trait d'encre à gauche, jamais la couleur de marque.
 *
 *   <Citation auteur="Max" extrait="tu fais quoi ce soir ?" onClick={() => rejoindre(id)} />
 */
import type { ReactNode } from "react";

import { cn } from "../utils";
import "./conversation.css";

export interface CitationProps {
  /** Qui l'a écrit. */
  auteur?: ReactNode;
  /** Une ligne : le texte, ou ce que c'était (« Photo », « Message supprimé »). */
  extrait: ReactNode;
  /** Rejoindre le message cité. Absent : la citation n'est pas cliquable. */
  onClick?: () => void;
  /** Dit au lecteur d'écran, quand c'est un bouton. Défaut « Aller au message cité ». */
  libelle?: string;
  className?: string;
}

export function Citation({ auteur, extrait, onClick, libelle = "Aller au message cité", className }: CitationProps) {
  const contenu = (
    <>
      {auteur !== undefined && auteur !== null && <span className="cv-citation-auteur">{auteur}</span>}
      <span className="cv-citation-extrait">{extrait}</span>
    </>
  );
  if (onClick) {
    return (
      <button type="button" className={cn("cv-citation", className)} onClick={onClick} title={libelle}>
        {contenu}
      </button>
    );
  }
  return <span className={cn("cv-citation", className)}>{contenu}</span>;
}
